<template>
    <div>
        <div class="img_bg">
            <div class="button_box">
                <div @click="build_phone_show" class="button"></div>
            </div>
        </div>
        <Popup v-model="popup_show"
        overlay-class="popup_box"
        :position="build_phone==2?'top':'center'"
        :close-on-click-overlay="build_phone==2?false:true"
        :lock-scroll="true"
        :lazy-render="false">
            <template v-if="build_phone==1">
                <div class="content_box">
                    <div class="title">输入手机号</div>
                    <input v-model="phone" @input="phone_input" maxlength="11" class="input_box" placeholder="输入绑定1688店铺的手机号" type="text">
                    <div @click="submit_phone" class="popup_button_box">
                        立即领取
                    </div>
                </div>
            </template>
            <template v-if="build_phone==2">
                <img class="build_phone_success" :src="$OSSBaseUrl+'build_phone_success.png'" alt="">
            </template>
            <!-- <template v-if="build_phone==2">
                <div class="content_box two">
                    <div class="build_phone_icon">
                        <img class="build_stetus_icon" :src="$OSSBaseUrl+'build_phone_icon.png'" alt="">
                    </div>
                    <div class="build_stetus_text">
                        <div>
                            已领取成功
                        </div>
                        <div>
                            等待客服与您联系
                        </div>
                    </div>
                    <div @click="close_popup" class="popup_button_box">
                        我知道了
                    </div>
                </div>
            </template> -->
        </Popup>
    </div>
</template>
<script>
import { Popup, Toast } from 'vant';
import verification from '@/utils/verification';
 
export default {
    name : 'Subsidy',
    components:{ 
        Popup
    },
    data(){
        return{
            popup_show: false,
            build_phone: 1,
            phone:'',
        }
    },
    created(){
        let data = {
            page_from:'main_page',
            page_name:'Subsidy',
            page_time:'0.00',
            receiver_id: '',
            page_param:{dayhour:this.$route.query.dayhour},
        };
        this.$store.dispatch('Public/inH5Record', data)
        this.$store.dispatch('Subsidy/verifActivity',{activity_name:'union_order_hx'}).then(res=>{
            if(res.code==1000){
                this.build_phone=1
            }else if(res.code==3002 ){
                this.build_phone=2
            }else{
                Toast(res.message)
            }
            this.popup_show = true
        })
    },
    methods:{
        phone_input(){
            let res = verification.int(this.phone)
            if(!res.state){
                this.phone = this.phone.substring(0,res.index)
            }
        },
        build_phone_show(){
            this.$store.dispatch('Subsidy/memberActivityPvStat',{activity_name:'union_order_hx'}).then(res=>{
                this.popup_show=true;
            })
        },
        submit_phone(){
            if(this.phone.length < 11){
                Toast("手机号码长度不够")
                return false
            }
            this.$store.dispatch('Subsidy/involvedActivity',{activity_name:"union_order_hx",activity_result:this.phone}).then(res=>{
                if(res.code==1000){
                    this.build_phone = 2;
                }else{
                    Toast(res.message)
                }
            })
        },
        close_popup(){
            this.popup_show=false;
        }
    },
}
</script>
<style lang="scss" scoped>
    @import './index.scss'
</style>